var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", { staticClass: "emd-text _color_subtle _type_caption eu-mb_1" }, [
      _vm._v(
        " " +
          _vm._s(_vm.$t("charge.detail.payment-method.card.billing-address")) +
          " "
      ),
    ]),
    _vm.hasBillingAddress
      ? _c("p", [
          _vm._v(
            " " +
              _vm._s(_vm.billingAddress.street) +
              ", " +
              _vm._s(_vm.billingAddress.number) +
              ", "
          ),
          _vm.billingAddress.complement
            ? _c("span", [
                _vm._v(" " + _vm._s(_vm.billingAddress.complement) + ", "),
              ])
            : _vm._e(),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.billingAddress.neighborhood) +
              ", " +
              _vm._s(_vm.billingAddress.city || "-") +
              ", " +
              _vm._s(_vm.billingAddress.state || "-") +
              " - " +
              _vm._s(_vm.billingAddress.country || "-") +
              " "
          ),
          _vm.billingAddress.zip_code
            ? _c("span", [
                _vm._v(" - " + _vm._s(_vm.billingAddress.zip_code) + " "),
              ])
            : _vm._e(),
        ])
      : _c("p", [_vm._v("-")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }